// Token offset decoding utility
// Separate file to avoid circular dependencies
const TOKEN_ALPHABET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
const TOKEN_OFFSET = 5;

export const descifrar = (encoded) => {
    if (!encoded) return '';
    const len = TOKEN_ALPHABET.length;
    return encoded.split('').map(ch => {
        const idx = TOKEN_ALPHABET.indexOf(ch);
        return idx === -1 ? ch : TOKEN_ALPHABET[(idx - TOKEN_OFFSET + len) % len];
    }).join('');
};
